import type { IdentityClaims, PrincipalKind } from "@istari-frontend/auth";

import type { IdentityMode } from "./identity-mode";

export const PLATFORM_ADMIN_ROLE = "admin";
export const TENANT_ADMIN_ROLE = "tenant_admin";

/** A platform admin administers every tenant; otherwise the token names the tenants administered. */
export type AdministeredTenants = { all: true } | { all: false; tenantIds: string[] };

/** Who the signed-in caller is and what they may administer, in every identity mode. */
export type Session = Pick<
  IdentityClaims,
  "principalId" | "principalKind" | "tenantId" | "tenantSlug" | "platformRoles" | "tenantRoles"
> & {
  mode: IdentityMode;
  isLoading: boolean;
  /** Transitional: the token's upstream_user_id, the join key from a person to their registry-service user. */
  upstreamUserId?: string;
  /** Transitional: the identity provider's organization id, which the Zitadel-keyed admin screens key on. */
  upstreamTenantId?: string;
  isPlatformAdmin: boolean;
  isTenantAdminOf: (tenantId: string | undefined) => boolean;
  administeredTenants: AdministeredTenants;
};

/** Whether the caller administers the tenant the token names: a platform admin, or a tenant admin of it. */
export function administersOwnTenant(session: Session): boolean {
  return session.isPlatformAdmin || session.isTenantAdminOf(session.tenantId);
}

export type { PrincipalKind };
